<!-- @format -->

<template>
	<div class="pcp-my-systems">
		<pc-image-text
			v-for="item in globalStore.subSystems"
			:key="item.id"
			:text="item.name"
			:url="item.logo"
			:on-click="() => toSubSystem(item)"
		/>
	</div>
</template>

<script setup lang="ts">
	import { useGlobalStoreWithOut } from '@power/runtime-vue3';
	import { toSubSystem } from './utils';
	import { PcImageText } from '@/components';

	const globalStore = useGlobalStoreWithOut();
</script>

<style scoped lang="scss">
	.pcp-my-systems {
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		justify-items: center;
		align-items: center;
		overflow-y: scroll;
		margin-bottom: 12px;
		gap: 10px;

		.pc-image-text {
			width: 100%;
			margin-top: 15px;
		}
	}
</style>
